import {useNavigate} from "react-router";
import {
    Button,
    Grid,
    GridItem,
    Image,
    Separator,
    Stack,
    Text,
    Flex,
    Progress,
    DialogBody
} from "@chakra-ui/react";
import {FaArrowRight} from "react-icons/fa";

// Custom imports
import {Parts, UI} from "components";
import {Styles} from "config";
import usePointsReport from "hooks/usePointsReport";
import useUser from "hooks/useUser";

import RuleOne from "components/parts/widgets/cruise/rule-one";
import RuleTwo from "components/parts/widgets/cruise/rule-two";
import RuleThree from "components/parts/widgets/cruise/rule-three";

import Campaign from "components/parts/widgets/campaigns/campaign";

import {useState} from "react";
import BestReferralCarousel from "../../components/parts/widgets/best-referral-carousel";

export default function Home() {
    const navigate = useNavigate();
    const handleCruiseClick = () =>
        window.open("https://consultor.bonificaoficial.com/cruzeirobnf/", "_blank");

    const user = useUser();
    const report = usePointsReport();
    const [warning, setWarning] = useState(true);

    const consultant = user.data?.consultant;
    const career = consultant?.career?.current_career;
    const careerStyle = Styles.pin(career?.id);

    return (
        <>
            <UI.Header title="Visão Geral"/>

            {/* Pop Up com aviso sobre produto Ioncell */}
            {/*<UI.Dialog*/}
            {/*    placement="center"*/}
            {/*    title="Aviso Importante"*/}
            {/*    size="lg"*/}
            {/*    lazyMount*/}
            {/*    open={warning}*/}
            {/*    onClose={() => setWarning(false)}*/}
            {/*>*/}
            {/*    <DialogBody>*/}
            {/*        <div >*/}
            {/*            <Image*/}
            {/*                src="/nota-oficial-organza_1.jpeg"*/}
            {/*                h="750px"*/}
            {/*                w="100%"*/}
            {/*                objectFit="contain"*/}
            {/*                borderRadius={6}*/}
            {/*                alt="Aviso Atualização Sistema"*/}
            {/*            />*/}
            {/*        </div>*/}
            {/*        /!*<div>*!/*/}
            {/*        /!*    <Text fontSize='md'>*!/*/}
            {/*        /!*        Prezados consultores,*!/*/}
            {/*        /!*    </Text>*!/*/}
            {/*        /!*    <br/>*!/*/}

            {/*        /!*    <Text fontSize='md'>*!/*/}
            {/*        /!*        Os saques estão sendo transferidos normalmente, porém devido ao processo de migração das operações de um banco público para um federal a ferramenta está com algumas limitações na velocidade dos pagamentos.*!/*/}
            {/*        /!*    </Text>*!/*/}
            {/*        /!*    <br />*!/*/}

            {/*        /!*    <Text fontSize='md'>*!/*/}
            {/*        /!*        <b>Esclarecimentos importantes:</b><br/>*!/*/}
            {/*        /!*        •	Finalidade do Ioncell Blocker: produto destinado exclusivamente a atuar como bloqueador/redução de radiações eletromagnéticas emitidas por dispositivos eletrônicos. <br />*!/*/}

            {/*        /!*        •	Ele NÃO é o mesmo produto BRACELET MHR nem utiliza as pastilhas/tecnologia MHR, utilizando apenas parte específica da tecnologia. <br />*!/*/}

            {/*        /!*        •	A suspensão não está relacionada a segurança ou qualidade do Ioncell Blocker, mas sim à padronização das mensagens para evitar interpretações incorretas, e os danos causados a credibilidade, real resultados para nossos clientes e comercial. <br />*!/*/}

            {/*        /!*    </Text>*!/*/}
            {/*        /!*    <br />*!/*/}

            {/*        /!*    <Text fontSize='md'>*!/*/}
            {/*        /!*        Fiquem tranquilos que a nossa equipe está empenhada, a previsão de finalização total dos pagamentos é até em 3 dias úteis.*!/*/}
            {/*        /!*    </Text>*!/*/}
            {/*        /!*    <br />*!/*/}

            {/*        /!*    <Text fontSize='md' fontWeight='semibold'>*!/*/}
            {/*        /!*        E o que muda para você?*!/*/}
            {/*        /!*    </Text>*!/*/}
            {/*        /!*    <br />*!/*/}

            {/*        /!*    <Text fontSize='md'>*!/*/}
            {/*        /!*        •	O produto continua o mesmo, com a mesma proposta de uso;<br />*!/*/}
            {/*        /!*        •	Apenas pausamos novas vendas enquanto ajustamos a comunicação oficial para que todas as informações ao público estejam claras, corretas e alinhadas ao fabricante;<br /><br />*!/*/}

            {/*        /!*        •	Avisaremos pelos canais oficiais quando as vendas forem retomadas.*!/*/}
            {/*        /!*    </Text>*!/*/}
            {/*        /!*    <br />*!/*/}

            {/*        /!*    <Text fontSize='md'>*!/*/}
            {/*        /!*        A Bonífica reafirma seu compromisso com a transparência, a ética e a comunicação responsável, comercializando somente produtos com alegações condizentes com sua finalidade e documentação técnica.*!/*/}
            {/*        /!*        Aviso legal: Ioncell Blocker não é medicamento nem dispositivo médico e não substitui diagnóstico, tratamento ou acompanhamento profissional de saúde.*!/*/}
            {/*        /!*    </Text>*!/*/}
            {/*        /!*    <br />*!/*/}

            {/*        /!*    <Text fontSize='md' fontWeight='semibold'>*!/*/}
            {/*        /!*        Atenciosamente, <br />*!/*/}
            {/*        /!*        Financeiro Bonífica.*!/*/}
            {/*        /!*    </Text>*!/*/}

            {/*        /!*</div>*!/*/}
            {/*    </DialogBody>*/}
            {/*</UI.Dialog>*/}


            {/* Banner do Cruzeiro */}
            {/*<Grid templateColumns={{ base: "1fr" }} gap={4} mb={4}>*/}
            {/*    <GridItem>*/}
            {/*        <Stack>*/}
            {/*            <UI.Box position="relative" overflow="hidden" borderRadius={6}>*/}
            {/*                <Image*/}
            {/*                    src="https://consultor.bonificaoficial.com/wp-content/uploads/2025/03/shutterstock_678153238-1920x1080-1.jpg"*/}
            {/*                    w="100%"*/}
            {/*                    h="250px"*/}
            {/*                    objectFit="cover"*/}
            {/*                    borderRadius={6}*/}
            {/*                    alt="Cruzeiro BNF"*/}
            {/*                />*/}
            {/*                <UI.Box*/}
            {/*                    position="absolute"*/}
            {/*                    top={{ base: "50%", md: "8%" }}*/}
            {/*                    left={{ base: "50%", md: "5%" }}*/}
            {/*                    transform={{ base: "translate(-50%, -40%)", md: "none" }}*/}
            {/*                    fontWeight="bold"*/}
            {/*                    fontSize={{ base: "xl", md: "2xl" }}*/}
            {/*                    h={{ base: "50%", md: "84%" }}*/}
            {/*                    zIndex={2}*/}
            {/*                    userSelect="none"*/}
            {/*                    textAlign="center"*/}
            {/*                    lineHeight="1.2"*/}
            {/*                    p={4}*/}
            {/*                    borderRadius={1}*/}
            {/*                    bg="rgba(0, 0, 0, 0.8)"*/}
            {/*                >*/}
            {/*                    <Text*/}
            {/*                        className="fadeBlink"*/}
            {/*                        color="white"*/}
            {/*                        animation="fadeBlink 2s infinite"*/}
            {/*                        fontSize={{ base: "0.8rem", md: "1rem" }}*/}
            {/*                    >*/}
            {/*                        Venha para o*/}
            {/*                    </Text>*/}
            {/*                    <Text*/}
            {/*                        className="fadeBlink"*/}
            {/*                        color="white"*/}
            {/*                        animation="fadeBlink 2s infinite 0.5s"*/}
            {/*                        fontSize={{ base: "xl", md: "4xl" }}*/}
            {/*                    >*/}
            {/*                        Cruzeiro*/}
            {/*                    </Text>*/}
            {/*                    <UI.Pressable onClick={handleCruiseClick}>*/}
            {/*                        <Stack align="center">*/}
            {/*                            <Text*/}
            {/*                                className="fadeBlinkOrange"*/}
            {/*                                animation="fadeBlinkOrange 1.5s infinite 1s"*/}
            {/*                                fontSize={{ base: "xl", md: "4xl" }}*/}
            {/*                            >*/}
            {/*                                Bonífica!*/}
            {/*                            </Text>*/}
            {/*                            <Flex align="center" justify="center" mt={2}>*/}
            {/*                                <FaArrowRight*/}
            {/*                                    size="0.5em"*/}
            {/*                                    style={{ marginRight: "5px" }}*/}
            {/*                                />*/}
            {/*                                <Text fontSize="sm" color="white">*/}
            {/*                                    Click aqui e conheça as regras*/}
            {/*                                </Text>*/}
            {/*                            </Flex>*/}
            {/*                        </Stack>*/}
            {/*                    </UI.Pressable>*/}
            {/*                </UI.Box>*/}
            {/*            </UI.Box>*/}
            {/*        </Stack>*/}
            {/*    </GridItem>*/}
            {/*</Grid>*/}

            {/* Widgets */}
            <Grid
                templateColumns={{
                    base: "1fr",
                    sm: "1fr",
                    md: "repeat(2, 1fr)",
                    lg: "repeat(3, 1fr)",
                }}
                gap={4}
            >

                {/*<GridItem>*/}
                {/*    <div style={{*/}
                {/*        width: '100%',*/}
                {/*        height: '608px',*/}
                {/*        overflow: 'hidden',*/}
                {/*        borderRadius: '6px',*/}
                {/*        border: '1px solid #E2E8F0',*/}
                {/*        display: 'flex',*/}
                {/*        flexDirection: 'column',*/}
                {/*        backgroundColor: '#18181b'*/}
                {/*    }}>*/}
                {/*        <div style={{ height: '530px', backgroundColor: 'black' }}>*/}
                {/*            <video*/}
                {/*                autoPlay*/}
                {/*                playsInline*/}
                {/*                controls*/}
                {/*                src="/videos/msg_presidente.mp4"*/}
                {/*                style={{*/}
                {/*                    width: "100%",*/}
                {/*                    height: "100%",*/}
                {/*                    objectFit: "cover",*/}
                {/*                    display: "block"*/}
                {/*                }}*/}
                {/*            >*/}
                {/*                <source src="/videos/msg_presidente.mp4" type="video/mp4" />*/}
                {/*            </video>*/}
                {/*        </div>*/}

                {/*        <Flex*/}
                {/*            flex="1"*/}
                {/*            align="center"*/}
                {/*            px={4}*/}
                {/*            bg="#18181b"*/}
                {/*            textAlign="center"*/}
                {/*        >*/}
                {/*            <Text*/}
                {/*                fontSize="sm"*/}
                {/*                color="white"*/}
                {/*                fontWeight="semibold"*/}
                {/*                lineHeight="1.5"*/}
                {/*            >*/}
                {/*                🚀 Mensagem exclusivo do nosso Presidente para você!*/}
                {/*                <br />*/}
                {/*                🧡 Vamos avançar juntos!*/}
                {/*            </Text>*/}
                {/*        </Flex>*/}
                {/*    </div>*/}
                {/*</GridItem>*/}

                {/*<GridItem>*/}
                {/*    <Parts.Widgets.Ads*/}
                {/*        image_url="PrimeiroSeminarioEstadualBonifica.png"*/}
                {/*        clickable={false}*/}
                {/*    />*/}
                {/*</GridItem>*/}

                {/*<GridItem>*/}
                {/*    <Parts.Widgets.Ads*/}
                {/*        image_url="live_09.jpeg"*/}
                {/*        bottom_message="Saúde no corpo e no Bolso🌎 A palavra é avançar.*/}
                {/*        Concorra a um sorteio de 5 Pix de 100 reais, 5 KITS DE CADASTRO, 5 perfumes BNF IMPORTS,*/}
                {/*        5 aromatizantes bucais,  5 Kits medida única e 5 bloqueadores de radiação eletromagnética (IONCELL)*/}
                {/*        💵 Envie esse banner para 15 pessoas e mande um print para o numero +55 62 99517-1897*/}
                {/*        já estará concorrendo ✨👐🏻💥💥 Sorteio na Live."*/}
                {/*        bottom_message_url="https://meet.google.com/tee-sstx-mxz"*/}
                {/*        clickable={false}*/}
                {/*    />*/}
                {/*</GridItem>*/}

                {/*<GridItem>*/}
                {/*    <Parts.Widgets.Ads*/}
                {/*        image_url="live_09.jpeg"*/}
                {/*        clickable={true}*/}
                {/*        bottom_message_url="https://www.instagram.com/p/DTiSIyyjrsV/?igsh=eGg1aDBkbHJpcHR3"*/}
                {/*    />*/}
                {/*</GridItem>*/}

                <GridItem>
                    <Parts.Widgets.ActiveMonth/>
                </GridItem>
                {/* <GridItem><Parts.Widgets.Note /></GridItem> */}
                <GridItem>
                    <Parts.Widgets.BlackBNF/>
                </GridItem>
                <GridItem>
                    <Parts.Widgets.DownlineRegister/>
                </GridItem>

                {/*carousel top recrutadores*/}
                <GridItem>
                    <Parts.Widgets.BestReferralCarousel/>
                </GridItem>

                {/*<GridItem>*/}
                {/*    <Parts.Widgets.Ads*/}
                {/*        image_url="comunicado_forma_pagamentos.jpeg"*/}
                {/*        clickable={false}*/}
                {/*    />*/}
                {/*</GridItem>*/}

                <GridItem>
                    <Parts.Widgets.BestReferral/>
                </GridItem>

                <GridItem>
                    <Parts.Widgets.Profile.Indication/>
                </GridItem>

                {/*<GridItem>
                    <Parts.Widgets.Ads
                        image_url="preco-posicionamento.jpeg"
                        clickable={false}
                    />
                </GridItem>
                <GridItem>
                    <Parts.Widgets.Ads
                        image_url="nova-linha-aromatizantes.jpeg"
                        clickable={false}
                    />
                </GridItem>*/}

                {/*<GridItem>
                    <Parts.Widgets.Profile.Indication />
                </GridItem>*/}

                {/*<GridItem>
                    <Parts.Widgets.PointsBonus />
                </GridItem>
                <GridItem>
                    <Parts.Widgets.Cycle />
                </GridItem>*/}

                {/*<GridItem>*/}
                {/*    <Parts.Widgets.Ads*/}
                {/*        image_url="post-instagram.png"*/}
                {/*        bottom_message="A Palavra é avançar 🌍🧡 Nossa missão é levar saúde no corpo e no bolso das famílias que buscam renda extra e liberdade financeira.*/}
                {/*        BONÍFICA MUNDI  Presidente Mark Onel"*/}
                {/*        bottom_message_url="https://www.instagram.com/p/DTiSIyyjrsV/?igsh=eGg1aDBkbHJpcHR3"*/}
                {/*        clickable={false}*/}
                {/*    />*/}
                {/*</GridItem>*/}

                {/*<GridItem>*/}
                {/*    <Parts.Widgets.Ads*/}
                {/*        image_url="aviso-adiamento-aumento.jpeg"*/}
                {/*        clickable={false}*/}
                {/*    />*/}
                {/*</GridItem>*/}
                {/* <GridItem>
                    <Parts.Widgets.Ads
                        image_url="live_presidencia.jpeg"
                        clickable={false}
                    />
                </GridItem> */}
                {/*<GridItem>*/}
                {/*    <Parts.Widgets.Ads*/}
                {/*        image_url="/sorteio-depoimento-2.jpeg"*/}
                {/*        clickable={false}*/}
                {/*    />*/}
                {/*</GridItem>*/}

                {/* Regras Cruzeiro */}
                {/*<GridItem>*/}
                {/*    <RuleOne />*/}
                {/*</GridItem>*/}
                {/*<GridItem>*/}
                {/*    <RuleTwo />*/}
                {/*</GridItem>*/}
                {/*<GridItem>*/}
                {/*    <RuleThree />*/}
                {/*</GridItem>*/}

                {/* <GridItem>
                    <Campaign />
                </GridItem> */}

                {/*<GridItem>*/}
                {/*    <Parts.Widgets.Network.Resume>*/}
                {/*        <Separator my={4} />*/}
                {/*        <Button size="xs" variant="ghost" onClick={() => navigate("/rede")}>*/}
                {/*            Relatório de rede*/}
                {/*        </Button>*/}
                {/*    </Parts.Widgets.Network.Resume>*/}
                {/*</GridItem>*/}
                {/* <GridItem><Parts.Widgets.Promo /></GridItem> */}
                {/*<GridItem>*/}
                {/*    <Parts.Widgets.Ads*/}
                {/*        image_url="https://generic.nyc3.cdn.digitaloceanspaces.com/static/atualizacao-chave-pix.jpg"*/}
                {/*        url="https://app.bonifi.ca/financeiro"*/}
                {/*    />*/}
                {/*</GridItem>*/}
                {/*<GridItem>*/}
                {/*    <Parts.Widgets.Ads*/}
                {/*        image_url="https://generic.nyc3.cdn.digitaloceanspaces.com/static/incricao.jpg"*/}
                {/*        url="https://lifebnf.bonificaoficial.com"*/}
                {/*    />*/}
                {/*</GridItem>*/}
            </Grid>

            {/* Estilos de animação */}
            <style>
                {`
          @keyframes fadeBlink {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }

          @keyframes fadeBlinkOrange {
            0%, 100% { opacity: 1; color: orange; }
            50% { opacity: 0.5; color: #ffa500cc; }
          }

          .fadeBlink {
            animation-timing-function: ease-in-out;
            animation-iteration-count: infinite;
            animation-name: fadeBlink;
            animation-duration: 2s;
          }

          .fadeBlinkOrange {
            animation-timing-function: ease-in-out;
            animation-name: fadeBlinkOrange;
            animation-duration: 1.5s;
          }
        `}
            </style>
        </>
    );
}
